export enum StreamingLibraryVersion {
    HLSJS = '1.0.7',
    SHAKA = '3.2.0',
    /** 
     * @deprecated
     */
    TWITCH = '1.1.2',
}
